export default function Webset() {
  return <>Webset</>;
}
